// extracted by mini-css-extract-plugin
module.exports = {"content":"styled-module--content--3ovt0","titleWrapper":"styled-module--title-wrapper--1QoAq"};